const EDITABLE_DETAILS_FIELDS = Object.freeze({
  loadType: 'loadTypeId',
  refNumbers: 'refNumbers',
  notes: 'notes',
  customFields: 'customFields',
  eta: 'eta',
  carrier: 'userId',
  units: 'units'
});

export default EDITABLE_DETAILS_FIELDS;
